import { useEffect, useState } from 'react';
import { getPropertyUtilities } from '../../../../api/properties/properties';
import { Utility } from '../../../../api/properties/types';
import { useUser } from '../../../../api/user/useUser';
import { UtilitySelectionStepView } from './UtilitySelectionStepView';

export interface UtilitySelectionStepProps {
  setStep: (stepName: string, props?: Record<string, unknown>) => void;
  propertyId: string;
}

export function UtilitySelectionStep({ setStep, propertyId }: UtilitySelectionStepProps) {
  const [isLoading, setIsLoading] = useState(false);
  const [utilities, setUtilities] = useState<Utility[]>([]);
  const TRACKING_ID = `takeover-utility-selection-step`;
  const { user, updateUserSettings } = useUser();

  useEffect(() => {
    const fetchUtilities = async () => {
      setIsLoading(true);
      const utilities = await getPropertyUtilities(propertyId);
      setUtilities(utilities);
      setIsLoading(false);
    };
    fetchUtilities();
  }, [propertyId]);

  const handleUtilitySelect = (utility: Utility) => {
    if (utility.utilityConnectionAvailable && utility.arcadiaProviderId) {
      if (user?.settings?.utilityNotSupported) {
        updateUserSettings({ utilityNotSupported: null });
      }
      setStep('connect-utility-login', { propertyId, providerId: utility.arcadiaProviderId });
    } else {
      updateUserSettings({ utilityNotSupported: { id: utility._id, name: utility.name } });
      setStep('utility-not-supported', { utility });
    }
  };

  const handleUtilityNotListed = () => {
    updateUserSettings({ utilityNotSupported: { notListed: true } });
    setStep('utility-not-supported');
  };

  return (
    <UtilitySelectionStepView
      utilities={utilities}
      isLoading={isLoading}
      propertyId={propertyId}
      onUtilitySelect={handleUtilitySelect}
      onUtilityNotListed={handleUtilityNotListed}
      trackingId={TRACKING_ID}
    />
  );
}

export default UtilitySelectionStep;
